import React from 'react';
import { Image as NBImage } from 'native-base';
import type { IImageProps } from './Image.types';
import {
  Platform,
  NativeSyntheticEvent,
  ImageLoadEventData,
} from 'react-native';

const Image: React.FunctionComponent<IImageProps> = ({
  autoResize,
  ...props
}) => {
  const [ratio, setAspectRatio] = React.useState<number | undefined>(16 / 9);
  const onLoadResize = (event: NativeSyntheticEvent<ImageLoadEventData>) => {
    if (autoResize) {
      if (Platform.OS === 'web') {
        setAspectRatio(
          //nativeEvent has different parameters in web
          //@ts-ignore
          event.nativeEvent.path[0].width / event.nativeEvent.path[0].height
        );
      } else {
        setAspectRatio(
          event.nativeEvent.source.width / event.nativeEvent.source.height
        );
      }
    }
  };
  return (
    <NBImage
      onLoad={props.onLoad ?? onLoadResize}
      style={{ aspectRatio: autoResize ? ratio : undefined }}
      {...props}
    />
  );
};

export default Image;
